import { GET_RECOMMENDED_IDEAS } from '../constants/APIUrlConstants';
import { IdeaListResponse, InternalServerError } from '../types/types';
import axiosInstance from '../utils/Axios';
import { handleAxiosError } from './HandleError';

type GetRecommendedIdeasResponse =
  | IdeaListResponse
  | InternalServerError
  | Error;

export const getRecommendedIdeas = async (
  userId: number,
  currentPage: number,
  totalPages: number,
): Promise<GetRecommendedIdeasResponse> => {
  try {
    const queryParams = new URLSearchParams();

    if (userId !== null && userId !== undefined) {
      queryParams.append('user_id', userId.toString());
    }
    if (currentPage !== null && currentPage !== undefined) {
      queryParams.append('page', currentPage.toString());
    }
    if (totalPages !== null && totalPages !== undefined) {
      queryParams.append('page_size', totalPages.toString());
    }

    const response = await axiosInstance.get<IdeaListResponse>(
      `${GET_RECOMMENDED_IDEAS}?${queryParams.toString()}`,
    );

    if (response.status === 200 && response.data) {
      return response.data;
    } else {
      return {
        status: response.status,
        code: 'INVALID_REQUEST',
        message: response.statusText,
      };
    }
  } catch (error) {
    console.error('failed to fetch the recommended ideas:', error);
    return handleAxiosError(
      error,
      'an error occurred while fetching the recommended ideas',
    );
  }
};
